export default "__VITE_ASSET__OsrFkkn3__"